currentLine